<template>
  <div class="bb-services-list" :class="{'bb-services-list_check-list': checkList}">
    <h2 class="bb-page-title bb-services-list__title" v-if="!checkList" ref="serviceTable">List of services</h2>
    <transition name="fade" appear>
      <loader-fly v-if="loaderRun"/>
    </transition>
    <div class="bb-services-list-header">
      <div class="bb-services-list-header-input-container">
        <input class="bb-services-list-header-input-container__input bb-input bb-input_search"
               type="text"
               @input="inputSearch"
               v-model="searchValue"
               placeholder="Search">
        <i class="icon-search bb-services-list-header-input-container__icon"></i>
      </div>
      <div class="bb-services-list-header-select-category">
        <custom-select :list="serviceCategories"
                       default-val="Category"
                       :filter-list="true"
                       title-class="bb-services-list-header-select-category__title"
                       placeholder-class="bb-services-list-header-select-category__placeholder"
                       @setValue='changeSelect'/>
      </div>
      <button class="bb-services-list-header__btn-add bb-button"
              @click.stop="openForm()"
              v-if="!checkList">
        ADD
      </button>
    </div>
    <div class="bb-tabs">
      <div
        class="bb-tabs__item"
        v-for="typeService in typesServices"
        :key="typeService.id"
        @click="changeActiveTab(typeService.id)"
        :class="{ 'bb-tabs__item_active': activeTab === typeService.id }">
        <span class="bb-tabs__title">{{ typeService.name }}</span>
      </div>
    </div>
    <div class="bb-services-list-table-wrapper"
         ref="bbServiceTable"
         :class="{'bb-services-list-table-wrapper_check-list': checkList}">
      <table class="bb-table bb-services-list-table">
        <thead class="bb-table-header bb-services-list-table-header">
        <tr class="bb-table-header-row">
          <th class="bb-table-header__item bb-table-header__item_hide"/>
          <th :class="{'bb-table-header__item bb-table-header__item_checkbox':checkList}"></th>
          <th class="bb-table-header__item">
            <div>
              CATEGORY
            </div>
          </th>
          <th class="bb-table-header__item bb-table-header__item_pointer"
          @click="sortByColumn('institution.name')">
            <div class="bb-table-header__item_name">
              INSTITUTION
              <i class="icon-arrow-sort bb-table-header__sort-icon"
              :class="{'bb-table-header__sort-icon_active': filterByColumn === 'institution.name'}"/>
            </div>
          </th>
          <th class="bb-table-header__item bb-table-header__item_project bb-table-header__item_pointer"
          @click="sortByColumn('project.name')">
            <div class="bb-table-header__item_name">
              PROJECT
              <i class="icon-arrow-sort bb-table-header__sort-icon"
              :class="{'bb-table-header__sort-icon_active': filterByColumn === 'project.name'}"/>
            </div>
          </th>
          <th class="bb-table-header__item bb-table-header__item_number">
            <div>
              FEE, AED
            </div>
          </th>
          <th class="bb-table-header__item bb-table-header__item_number">
            <div>
              VAT (<i class="icon-percent"/>)
            </div>
          </th>
          <th class="bb-table-header__item bb-table-header__item_number">
            <div>
              VAT (AED)
            </div>
          </th>
          <th class="bb-table-header__item bb-table-header__item_number">
            <div>
              TOTAL, AED
            </div>
          </th>
          <th class="bb-table-header__item bb-table-header__item_toolbar"/>
          <th class="bb-table-header__item bb-table-header__item_hide"/>
        </tr>
        </thead>
        <tbody class="bb-table-body">
        <tr class="bb-table-body-row" v-for="(serviceItem, index) in servicesList"
            :key="serviceItem.id"
            @mouseenter="setActiveRow(index)"
            @mouseleave="rowActive = false, deleteConfirmIndex = false"
            v-if="!checkList || isChecked(serviceItem)"
            @click.stop="checkboxChangeRow(serviceItem)"
            :class="{
            'bb-table-body-row_payment': checkList,
            'bb-table-body-row_active':rowActive === index && !checkList,
            'bb-table-body-row_check-list': checkList}">
          <td><div class="bb-table-body-row__after" :ref="'bbRowAfter'+index"/></td>
          <td :class="{'bb-table-body__item': checkList}">
            <checkbox
              :name="serviceItem.id"
              :section="serviceItem"
              @checkboxChange="checkboxChange"
              :value="getChecked(serviceItem)"
              v-if="checkList"/>
          </td>
          <td class="bb-table-body__item">
            <div>
              {{getNameCategory(serviceItem)}}
            </div>
          </td>
          <td class="bb-table-body__item">
            <div>
              {{serviceItem.institution ? serviceItem.institution.name : ''}}
            </div>
          </td>
          <td class="bb-table-body__item">
            <div>
              {{serviceItem.project ? serviceItem.project.name : ''}}
            </div>
          </td>
          <td class="bb-table-body__item">
            <div>
              {{convertNumber(serviceItem.value)}}
            </div>
          </td>
          <td class="bb-table-body__item">
            <div>
              {{calculations(serviceItem).vat}}
            </div>
          </td>
          <td class="bb-table-body__item">
            <div class="bb-table-body__item_vat-aed">
              {{calculations(serviceItem).aed > 0 ? convertNumber(calculations(serviceItem).aed) :
              calculations(serviceItem).aed}}
            </div>
          </td>
          <td class="bb-table-body__item">
            <div>
              {{convertNumber(calculations(serviceItem).total)}}
            </div>
          </td>
          <td class="bb-table-body__item">
            <Toolbar v-if="rowActive === index && !checkList"
                     :delete-index="deleteConfirmIndex"
                     :index="index"
                     :item="serviceItem"
                     @deleteOpen="deleteConfirmIndex = index"
                     @deleteClose="deleteConfirmClose()"
                     @openEdit="openEditForm"
                     @deleteItem="deleteService"/>
          </td>
        </tr>
        </tbody>
      </table>
    </div>
    <Pagination :data="fullServicesInfo" :getQuery="getServices" :limit="defLimit" class="bb-pagination"/>
  </div>
</template>

<script>
import CustomSelect from '@/components/Main/Inputs/CustomSelect'
import Toolbar from '@/components/Main/Toolbar/Toolbar'
import ServicesApi from '@/api/Services/api'
import checkbox from '@/components/Main/Inputs/checkbox'
import convertNumber from '@/mixin/convertNumber'
import Pagination from '@/components/Main/Pagination/Pagination'
import LoaderFly from '@/components/Main/Loaders/LoaderFly'
import serviceCategoriesList from '@/mixin/serviceCategoriesList'

import _ from 'lodash'

export default {
  name: 'ServicesList',
  props: ['settings', 'checkList', 'checkedList'],
  mixins: [convertNumber, serviceCategoriesList],
  components: {
    CustomSelect,
    checkbox,
    Toolbar,
    Pagination,
    LoaderFly
  },
  data: function () {
    return {
      activeTab: 1,
      typesServices: [
        {
          id: 1,
          name: 'Price List'
        },
        {
          id: 2,
          name: 'One-Time Entries'
        }
      ],
      loaderRun: false,
      fullServicesInfo: '',
      defLimit: 30,
      rowActive: false,
      deleteConfirmIndex: false,
      checked: [],
      filterByCategory: false,
      filterByColumn: '',
      searchWords: '',
      searchValue: ''
    }
  },
  computed: {
    serviceCategories: {
      get: function () {
        return this.$store.getters.serviceCategories
      },
      set: function (data) {
        this.$store.dispatch('setServiceCategories', data)
      }
    },
    servicesList: {
      get: function () {
        return this.$store.getters.servicesList
      },
      set: function (data) {
        this.$store.dispatch('setServicesList', data)
      }
    },
    activeCompany: function () {
      return this.$store.getters.activeCompany
    },
    getWithSearch: function () {
      return _.debounce(this.getServices, 250)
    }
  },
  methods: {
    changeActiveTab (id) {
      this.activeTab = id
      this.searchValue = ''
      this.$emit('changeTab', id)
      this.getServices({limit: this.defLimit, noScroll: true})
    },
    inputSearch (e) {
      const val = e.target.value
      const searchValue = val.toLowerCase().trim()
      this.getWithSearch({page: 1, limit: this.defLimit, search: searchValue})
    },
    setActiveRow (index) {
      this.rowActive = index
      const widthTable = _.get(this.$refs, 'bbServiceTable.offsetWidth', false)
      const afterElement = _.get(this.$refs, `bbRowAfter${index}`, [])
      if (widthTable && afterElement[0]) {
        afterElement[0].style.width = widthTable + 'px'
      }
    },
    sortByColumn (column) {
      if (column === this.filterByColumn) {
        this.filterByColumn = column + '&sort[]=-1'
      } else {
        this.filterByColumn = column
      }
      this.getServices({limit: this.defLimit, noScroll: true})
    },
    getNameCategory (service) {
      const res = _.find(this.serviceCategories, item => item.id === service.serviceType)
      return res ? res.name : ''
    },
    isChecked (service) {
      let checkedService = _.find(this.checkedList, {
        vat: service.vat,
        value: service.value,
        name: service.name,
        serviceType: service.serviceType
      })
      return !checkedService
    },
    getChecked (service) {
      const checkedService = _.find(this.checked, {
        vat: service.vat,
        value: service.value,
        name: service.name,
        serviceType: service.serviceType
      })
      return checkedService
    },
    checkboxChange (data, id, item) {
      if (data) {
        this.checked.push(item)
      } else {
        const index = this.checked.indexOf(item)
        this.checked.splice(index, 1)
      }
    },
    checkboxChangeRow (item) {
      if (!this.checkList) {
        return
      }
      const index = this.checked.indexOf(item)
      if (index < 0) {
        this.checked.push(item)
      } else {
        this.checked.splice(index, 1)
      }
    },
    getCategories () {
      this.serviceCategories = this.serviceCategoriesList
    },
    scrollUp (noScroll) {
      const serviceTable = this.$refs.serviceTable || this.$refs.bbServiceTable
      const parentScroll = this.checkList ? this.$parent.$el : this.$parent.$parent.$el
      if (serviceTable && !noScroll) {
        const positionTop = _.get(serviceTable.getBoundingClientRect(), 'top', 320)
        const topWithScroll = positionTop + parentScroll.scrollTop
        const scrollTo = this.checkList ? 0 : topWithScroll
        parentScroll.scrollTop = scrollTo
      }
    },
    getServices ({query, limit, page, noScroll, search}) {
      this.loaderRun = true
      this.scrollUp(noScroll)
      if (this.filterByCategory !== false && !query) {
        query = 'serviceType[]=' + this.filterByCategory
      }
      if (this.filterByColumn) {
        const filterQuery = 'sort[]=' + this.filterByColumn
        query ? query += '&' + filterQuery : query = filterQuery
      }
      search ? this.searchWords = `&search=${search}` : this.searchWords = ''
      if (this.searchWords) {
        query ? query += this.searchWords : query = this.searchWords
      }
      ServicesApi.getServices({query, limit, page, oneTime: this.activeTab === 2})
        .then((resp) => {
          this.loaderRun = false
          this.fullServicesInfo = resp.data
          const services = _.filter(resp.data.services, item => item)
          this.servicesList = _.uniqWith(services, (arrVal, othVal) => {
            const vat = arrVal.vat === othVal.vat
            const value = arrVal.value === othVal.value
            const name = arrVal.name === othVal.name
            const serviceType = arrVal.serviceType === othVal.serviceType
            return vat && value && name && serviceType
          })
        })
        .catch((err) => {
          this.loaderRun = false
          console.error(err)
        })
    },
    deleteService (index, id) {
      ServicesApi.deleteService(id)
        .then((resp) => {
          this.deleteConfirmIndex = false
          this.servicesList.splice(index, 1)
        })
        .catch((err) => {
          console.error(err)
        })
    },
    calculations (item) {
      let vat
      let aed = 1
      let total
      if (isNaN(item.vat)) {
        vat = 'N/A'
      } else if (+item.vat === 0) {
        vat = 0
      } else {
        vat = this.settings.vat
      }
      if (vat === 'N/A') {
        aed = 'N/A'
        total = item.value
      } else {
        aed = +item.value * vat / 100
        total = +item.value + aed
      }
      return {
        vat: vat > 0 ? vat + '%' : vat,
        aed: aed,
        total: +total
      }
    },
    changeSelect (item) {
      if (!item) {
        return
      }
      if (item.id === 'all') {
        this.filterByCategory = false
        this.getServices({limit: this.defLimit, noScroll: true})
        return
      }
      this.filterByCategory = item.id
      this.getServices({query: `serviceType[]=${item.id}`, limit: this.defLimit, noScroll: true})
    },
    deleteConfirmClose () {
      this.deleteConfirmIndex = false
    },
    openForm () {
      this.$emit('openForm')
    },
    openEditForm (index, item) {
      this.$emit('openEditForm', item, index)
    },
    addServicesCheckList () {
      this.$emit('addServices', this.checked)
    }
  },
  watch: {
    activeCompany: function () {
      this.getCategories()
      this.getServices({limit: this.defLimit})
    }
  },
  beforeDestroy () {
    this.getServices({limit: this.defLimit})
  },
  beforeMount () {
    if (this.checkedList) {
      this.checkedList.forEach(item => this.checked.push(item))
    }
    if (this.serviceCategories.length === 0 || this.serviceCategories[0].company !== this.activeCompany) {
      this.getCategories()
    }
    this.getServices({limit: this.defLimit})
  }
}
</script>

<style lang="scss" scoped>
  @import "../../../../sass/variables";
  @import "../../../../sass/mixins";

  .bb-services-list {
    margin-top: 62px;

    &_check-list {
      margin-top: 0;
    }

    &__title {
      font-size: 18px;
      line-height: 21px;
      margin-bottom: 35px;
    }

    &-header {
      display: flex;
      margin-bottom: 31px;

      &-select-category {
        @include global-font;
        margin: 0 20px;
        width: 233px;
        height: 42px;
        font-size: 12px;
        line-height: 14px;
      }

      &-input-container {
        position: relative;
        display: flex;
        align-items: center;

        &__input {
          min-width: 578px;
          height: 42px;
          border-radius: 6px;
          padding-left: 40px;
          border: 1px solid $color-wild-sand;
        }

        &__icon {
          position: absolute;
          left: 13px;
          font-size: 15px;
          color: $color-silver;
        }
      }

      &__btn-add {
        margin-left: auto;
        width: 73px;
      }
    }

    &-table-wrapper {
      position: relative;
      width: 100%;
      background: $color-white;
      box-shadow: 0 0 20px rgba($color-black, 0.05);
      border-radius: 0 5px 5px 5px;
      min-width: 1200px;

      &_check-list {
        padding: 0;
        margin-top: 0;
        box-shadow: none;
      }
    }
  }

</style>

<style lang="scss">
  @import "../../../../sass/variables";

  .bb-services-list-header-select-category__placeholder {
    color: $color-silver;
    font-size: 14px;
    line-height: 24px;
  }

  .bb-services-list-header-select-category__title {
    line-height: 24px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Settings/Services/ServicesList/ServicesList.vue